import { loginIn, getInfo, loginOut } from '@/api/modules/user'
import { getItem, setItem, removeItem } from '@/utils/auth'

const state = {
    token: getItem('token'),
    roles: [],
    userInfo: {},
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_ROLES: (state, roles) => {
        state.roles = roles
    },
    SET_USER_INFO: (state, info) => {
        state.userInfo = info
    }
}

const actions = {
    // user login
    loginIn({ commit }, userInfo) {
        const { username, password } = userInfo
        return new Promise((resolve, reject) => {
            loginIn({
                username: username.trim(),  // 去除首尾空格
                password: password
            }).then(res => {
                // console.log(res)

                // 保存 token
                commit('SET_TOKEN', res.data.token)
                setItem('token', res.data.token)

                resolve()
            }).catch(error => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                commit('SET_USER_INFO', {})
                removeItem('token')
                reject(error)
            })
        })
    },

    // 获取用户信息
    getUserInfo({ commit, state }, hasToken) {
        return new Promise((resolve, reject) => {
            getInfo({ token: hasToken ? hasToken : state.token}).then(res => {
                const { data } = res

                if (!data) {
                    reject('验证失败，请重新登录')
                }

                commit('SET_USER_INFO', data)
                resolve(data)
            }).catch(err => {
                reject(err)
            })
        })
    },

    // 退出登录
    loginOut({ commit }) {
        return new Promise((resolve, reject) => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            commit('SET_USER_INFO', {})
            removeItem('token')

            resolve()
        })
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}